import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
// @ts-ignore — AuthContext es JSX
import { AuthProvider } from '@/contexts/AuthContext';
import { PlaySessionProvider } from '@/play/contexts/PlaySessionContext';
import JuniorApp from './App';
import './index.css';
import './styles/presentation.css';

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <PlaySessionProvider>
          <JuniorApp />
        </PlaySessionProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
